/**
 * This pipe is used to display the tooltip for a row column context.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '../table.model';

@Pipe({
  name: 'rowColumnTooltip',
  standalone: true,
})
export class RowColumnTooltipPipe implements PipeTransform {
  transform(row: Record<string, any>, column: TableColumn): string | null {
    const { rowColumnTooltip } = column;

    if (rowColumnTooltip == null) return null;

    return typeof rowColumnTooltip === 'function' ? rowColumnTooltip(row) : rowColumnTooltip;
  }
}
